<template>
  <el-dialog
    class="three-model-dialog"
    title="监控画面"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :append-to-body="true"
    :modal="true"
    width="70%"
    top="10vh"
    v-dialogDrag
  >
    <div style="height:500px;overflow:hidden;">
      <!-- rtsp流播放 -->
      <RtspPlayer v-if="cameraInfo['protocolTypeCode']==='RtspToWs'" :code="code" :cameraInfo="cameraInfo" :pIid="pIid"></RtspPlayer>
      <!-- 紫光华智 -->
      <UniSinSight v-else-if="manufacturerCode==='UniSinSight'" :code="code" :showControlPanel="showControlPanel"></UniSinSight>
      <!-- 宇视 -->
      <YSPlayer v-else-if="manufacturerCode==='UniView' && !isUseNewVersion" :code="code" :showControlPanel="showControlPanel" :pIid="pIid"></YSPlayer>
      <NewYSPlayer v-else-if="manufacturerCode === 'UniView' && isUseNewVersion" :code="code" :showControlPanel="showControlPanel" :pIid="pIid" :name="name"></NewYSPlayer>
      <!-- 大华 -->
      <DHWSPlayerControl v-else-if="manufacturerCode === 'DaHua'" :daHuaParams="daHuaParams"></DHWSPlayerControl>
      <!-- 海康 -->
      <HKPlayerControl v-else-if="manufacturerCode === 'Hik' && showHKControlPanel" :showHKControlPanel="showHKControlPanel" :cameraIndexCode="code"></HKPlayerControl>
      <HKPlayer v-else-if="manufacturerCode === 'Hik' && !isWebControl" :cameraIndexCode="code"></HKPlayer>
      <HKWebControlPlayer v-else-if="manufacturerCode === 'Hik' && isWebControl && !notCanUseVideoWebPlugin" :id="code" :cameraIndexCode="code" @downloadDialog="downloadDialog"></HKWebControlPlayer>
      <HKPlayer v-else-if="manufacturerCode === 'Hik' && isWebControl && notCanUseVideoWebPlugin" :cameraIndexCode="code"></HKPlayer>
    </div>
  </el-dialog>
</template>

<script>
import _ from 'lodash'
import YSPlayer from './YSPlayer/YSPlayerControl'
import HKPlayer from './HKPlayer/index'
import HKWebControlPlayer from './HKPlayer/WebIndex'
import UniSinSight from './UniSinSight/index'
import DHWSPlayerControl from './DHPlayer/DHWSPlayerControl'
import HKPlayerControl from './HKPlayer/HKPlayerControl'
import RtspPlayer from './RtspPlayer/index'
import NewYSPlayer from './YSPlayer/NewYSPlayer'

export default {
  props: {
    show: Boolean,
    // 摄像头编码
    code: {
      type: String,
      defalut: '',
    },
    // 摄像头名称
    name: {
      type: String,
      default: ''
    },
    // 是否显示云台和历史播放的操作面板;默认进来是实时播放模式，控制面板打开
    showControlPanel: {
      type: Boolean,
      default: true,
    },
    pIid: {
      type: String,
      defalut: '',
    },
    manufacturerCode: {
      type: String,
      defalut: '',
    },
    daHuaParams: {
      type: Object,
      default: () => {}
    },
    cameraInfo: {
      type: Object,
      default: () => {}
    },
    // 海康是否使用WebControl的方式
    isWebControl: {
      type: Boolean,
      defalut: false,
    },
    // 是否展示海康云台控制面板
    showHKControlPanel: {
      type: Boolean,
      defalut: false,
    },
  },
  components: {
    YSPlayer,
    HKPlayer,
    HKWebControlPlayer,
    UniSinSight,
    DHWSPlayerControl,
    HKPlayerControl,
    RtspPlayer,
    NewYSPlayer,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      },
    },
    notCanUseVideoWebPlugin() { // 现场环境是否不支持使用插件方式
      return _.get(
        Wiz,
        'globalSettings.dynamicModules.modules["wiz-iot-management"].config.notCanUseVideoWebPlugin'
      )
    },

    // 是否使用新版的宇视
    isUseNewVersion() {
      return _.get(Wiz, 'globalSettings.dynamicModules.modules["wiz-iot-management"].config')
        ?.NewYSPlayerConfig?.isUseNewYS || false
    },
  },
  methods: {
    /**
     * 监听是否安装海康播放器插件
     * 当用户未下载插件时，弹出弹框支持在线下载
     */
    downloadDialog() {
      if (this.dialogShow && this.isWebControl) {
        this.$confirm('插件启动失败，请检查插件是否安装或点击下载按钮进行下载!', '提示', {
          confirmButtonText: '下载',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            // 安装包放在服务器上
            window.location.href = '/static/hik/VideoWebPlugin.exe'
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消下载',
            })
          })
        this.dialogShow = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
